export function PageHeader({ eyebrow, title, description, children, testid }) {
  return (
    <div className="mb-10 flex flex-col gap-4 md:flex-row md:items-end md:justify-between" data-testid={testid}>
      <div>
        {eyebrow && <div className="cm-label mb-2">{eyebrow}</div>}
        <h1 className="font-display text-4xl tracking-tight md:text-5xl">{title}</h1>
        {description && <p className="mt-3 max-w-2xl text-sm text-[#A1A19D]">{description}</p>}
      </div>
      {children && <div className="flex items-center gap-2">{children}</div>}
    </div>
  );
}

export function Section({ title, children, action }) {
  return (
    <section className="mb-12">
      {(title || action) && (
        <div className="mb-4 flex items-center justify-between border-b border-[#2C2C2A] pb-2">
          {title && <h2 className="cm-label">{title}</h2>}
          {action}
        </div>
      )}
      {children}
    </section>
  );
}

export function Metric({ label, value, note, highlight }) {
  const unverified = value === null || value === undefined;
  return (
    <div className="border border-[#2C2C2A] bg-[#1A1A18] p-6">
      <div className="cm-label mb-3">{label}</div>
      {unverified ? (
        <div className="font-display text-2xl text-[#F59E0B]">Not verified</div>
      ) : (
        <div className={`font-display text-2xl ${highlight ? "text-[#F59E0B]" : "text-[#F9F9F8]"}`}>{value}</div>
      )}
      {note && <div className="mt-2 text-xs text-[#A1A19D]">{note}</div>}
    </div>
  );
}

export function SourceLink({ url, label = "Source", testid }) {
  if (!url) {
    return <span className="text-xs text-[#6b6b66] italic">Link pending</span>;
  }
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testid}
      className="inline-flex items-center gap-1 text-xs text-[#F59E0B] underline-offset-2 hover:underline"
    >
      {label} ↗
    </a>
  );
}

export function EmptyState({ title, description, testid }) {
  return (
    <div className="border border-dashed border-[#2C2C2A] bg-[#161614] p-10 text-center" data-testid={testid}>
      <div className="font-display text-xl text-[#F9F9F8]">{title}</div>
      {description && <p className="mt-2 text-sm text-[#A1A19D]">{description}</p>}
    </div>
  );
}
